export const COMMAND_AVAILABLE_TYPES = [{ id: 'custom_msg', title: 'Custom message' }];
